import store from '../store'

export function getTheme(){
	const state = store.getState()
	return state.theme
}
